import { useQuery } from 'react-query';
import { queryPendingCompany } from './usePendingCompany.query';
import { UsePendingCompanyOptions } from './usePendingCompany.types';
import { PendingCompany } from '../../../types/models/company/company.types';

export const PENDING_COMPANY_QUERY_KEY = 'PENDING_COMPANY';

export const usePendingCompany = (options?: UsePendingCompanyOptions) => {
  return useQuery<PendingCompany, Error>(PENDING_COMPANY_QUERY_KEY, () => queryPendingCompany(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
